import http from "./apiServices"

export const getAuditLogs = ({ type, id }) => {
  return http.get(`audit-logs/${type}/${id}`)
}
